import React from "react";
import Typography from "@material-ui/core/Typography";
import EpayPaymentInformation from "./EpayPaymentInformation";
import { Dialog as GenericDialog, GenericDialogProps } from "../../dialog";
import { Button } from "@material-ui/core";
import pdfIcon from "../../../styles/images/pdfIcon.png";
import paymentMethod from "../../../pages/client/Enrollment/EnrollmentHome/payment/PaymentMethod";
import { usePolicyContext } from "./PolicyContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";


export default function EpayPayment(props: any) {
    const { onClose } = props;
    const handleClose = () => {
        onClose();
    };


    const dialogProps: GenericDialogProps = {
        "aria-labelledby": "customized-dialog-title",
        fullWidth: true,
        maxWidth: "md",
        content: (
                <>
                    <EpayPaymentAdd handleClose={handleClose}  />
                </>
        ),
        dividers: true,
        onClose: handleClose,
        open: true,
        title: "Make Online ePay (ACH) Payment",
        titleVariant:'subtitle1',
        //dialogClassName: "zIndex9999",
    };


    return (
            <GenericDialog {...dialogProps} />
    );
}


export function EpayPaymentAdd(props: any) {
    const {policy}: any = usePolicyContext();
    const profile = useSelector((state: RootState) => state.profile);
    const paymentFrequency: string = profile.client && profile.client.clientPolicies && profile.client.clientPolicies[0] && profile.client.clientPolicies[0].paymentFrequency || "annual";
    const getNextPayments = (policy) =>{
        if(policy){
            const timeTable = paymentFrequency === "annual" ? policy.paymentTimetableAnnual : policy.paymentTimetableMonthly;
            return  timeTable.nextPayment
        }
        return false
    }

    if(!getNextPayments(policy)){
        return (<Typography variant="body1" component="strong" className="mt20 floatLeft w100 mb0">
            No Pending Payment
        </Typography>)
    }
    return (
            <>
                <Typography variant="caption">You can make an online ePayment using a checking account. Payment will
                    go towards your
                    next annual contribution amount due. If you make a payment exceeds your next annual contribution
                    amount, the additional funds will be applied to the following contribution year(s). Once payment
                    is approved, your contribution totals and payment history will be updated.
                </Typography>
                <EpayPaymentInformation handleClose={props.handleClose} source="AddEpayPayment" />
            </>
    );
}








export function BackToPayments() {
    return (
            <>
                <Button variant="contained" color="primary" className="floatRight mt20 mb20"> Back to Payments</Button>
            </>
    );
}

